'use strict';
import * as $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData from "./app.components.-App-Main-Modal$-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_components_AppMainModal$Data$OnAuthError(err, definedAt) {
  this.Lapp_components_AppMainModal$Data$OnAuthError__f_err = null;
  this.Lapp_components_AppMainModal$Data$OnAuthError__f_definedAt = null;
  this.Lapp_components_AppMainModal$Data$OnAuthError__f_err = err;
  this.Lapp_components_AppMainModal$Data$OnAuthError__f_definedAt = definedAt;
}
export { $c_Lapp_components_AppMainModal$Data$OnAuthError as $c_Lapp_components_AppMainModal$Data$OnAuthError };
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype = new $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData.$h_Lapp_components_AppMainModal$Data();
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.constructor = $c_Lapp_components_AppMainModal$Data$OnAuthError;
/** @constructor */
function $h_Lapp_components_AppMainModal$Data$OnAuthError() {
}
export { $h_Lapp_components_AppMainModal$Data$OnAuthError as $h_Lapp_components_AppMainModal$Data$OnAuthError };
$h_Lapp_components_AppMainModal$Data$OnAuthError.prototype = $c_Lapp_components_AppMainModal$Data$OnAuthError.prototype;
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1447783551, true);
});
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_components_AppMainModal$Data$OnAuthError) && (this.Lapp_components_AppMainModal$Data$OnAuthError__f_err === x$0.Lapp_components_AppMainModal$Data$OnAuthError__f_err)));
});
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.productPrefix__T = (function() {
  return "OnAuthError";
});
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_components_AppMainModal$Data$OnAuthError__f_err;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$OnAuthError.prototype.definedAt__Lframework_sourcecode_DefinedAt = (function() {
  return this.Lapp_components_AppMainModal$Data$OnAuthError__f_definedAt;
});
function $isArrayOf_Lapp_components_AppMainModal$Data$OnAuthError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_components_AppMainModal$Data$OnAuthError)));
}
export { $isArrayOf_Lapp_components_AppMainModal$Data$OnAuthError as $isArrayOf_Lapp_components_AppMainModal$Data$OnAuthError };
var $d_Lapp_components_AppMainModal$Data$OnAuthError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_components_AppMainModal$Data$OnAuthError, "app.components.AppMainModal$Data$OnAuthError", ({
  Lapp_components_AppMainModal$Data$OnAuthError: 1,
  Lapp_components_AppMainModal$Data: 1,
  Lframework_components_FrameworkMainModal$Data: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_components_AppMainModal$Data$OnAuthError as $d_Lapp_components_AppMainModal$Data$OnAuthError };
//# sourceMappingURL=app.components.-App-Main-Modal$-Data$-On-Auth-Error.js.map
